var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "gobierto-filter-checkbox",
      attrs: { id: _vm.createIdCheckbox() }
    },
    [
      _c("input", {
        staticClass: "gobierto-filter-checkbox--input",
        attrs: { id: "checkbox-" + _vm.id + "-" + _vm.seed, type: "checkbox" },
        domProps: { checked: _vm.checked },
        on: { change: _vm.onChange }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "gobierto-filter-checkbox--label",
          attrs: { for: "checkbox-" + _vm.id + "-" + _vm.seed }
        },
        [
          _c("div", { staticClass: "gobierto-filter-checkbox--label-title" }, [
            _c(
              "p",
              { staticClass: "gobierto-filter-checkbox--label-title-text" },
              [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
            ),
            _vm._v(" "),
            _vm.hasCounter
              ? _c(
                  "i",
                  { staticClass: "gobierto-filter-checkbox--label-counter" },
                  [_vm._v("(" + _vm._s(_vm.counter) + ")")]
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }